import type React from "react";

import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import type { Invoice } from "api/services/admin/schemas";
import { NotificationBox } from "shared/atoms/NotificationBox/NotificationBox";
import { convertCentsToDollarsNumber } from "utils/convertCentsToDollars";
import { translateCurrency } from "utils/translations/translateCurrency";

interface Props {
  invoice: Invoice;
}

export const InvoiceNotificationBox: React.FC<Props> = ({ invoice }) => {
  const { t } = useTranslation();

  const amount = translateCurrency(convertCentsToDollarsNumber(invoice.amount_due), invoice.currency.toUpperCase());

  return (
    <NotificationBox
      icon={faTriangleExclamation}
      color="orange"
      label={t("admin.subscription.unpaid_invoice", { amount })}
      buttonText={t("admin.subscription.view_invoice")}
      onClick={() => {
        if (invoice.hosted_invoice_url) {
          window.open(invoice.hosted_invoice_url, "_blank");
        }
      }}
    />
  );
};
